import superjson from 'superjson';

superjson.registerCustom(
  {
    isApplicable: (v: any): v is unknown => {
      return v && v._bsontype;
    },
    serialize: () => {
      return undefined;
    },
    deserialize: () => {
      return undefined;
    },
  },
  'id'
);

superjson.registerCustom(
  {
    isApplicable: (v: any): v is unknown => {
      return v && v.toObject;
    },
    serialize: (v: any) => {
      return transformer.serialize(v.toObject());
    },
    deserialize: (v: any) => {
      return transformer.deserialize(v);
    },
  },
  'object'
);

export const transformer = superjson;
